import * as React from 'react';

import { cn } from '@/lib/utils';

type ContainerProps = {
  children: React.ReactNode;
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
  spacing?: number;
  className?: string;
};

export function Container({
  children,
  direction = 'row',
  spacing = 2,
  ...props
}: ContainerProps & React.HTMLAttributes<HTMLDivElement>) {
  const directionClass = {
    row: 'flex-row',
    'row-reverse': 'flex-row-reverse',
    column: 'flex-col',
    'column-reverse': 'flex-col-reverse',
  }[direction];

  const gapClass = `gap-${spacing}`;

  return (
    <div className={cn('flex', directionClass, gapClass)} {...props}>
      {children}
    </div>
  );
}
